import React, { useEffect, useState} from "react";

import {
    Card,
    Col,
} from "react-bootstrap";


import {useParams} from "react-router-dom";
import tableDataModules from "../../controller/tableDataModules";
import EditForm from "./EditForm";


function Viewer() {
    let { caseid } = useParams();
    let caseID = caseid;

    const [caseData,setCaseData] = useState("");
    useEffect(()=>{
        tableDataModules.getCaseData(caseID).then(res => {
            setCaseData(res);
        });
    }, [caseID]);
    return(
        <>
            <Col xs={{span: 11}}>
                <Card >
                    <Card.Body>

                        {caseData !== "" ? <EditForm caseID={caseID} caseData={caseData}/> : ''}
                    </Card.Body>
                </Card>
            </Col>


        </>
    )
}

export default Viewer;